<h3 mat-dialog-title>Save As..</h3>
<mat-dialog-content>
  <form>
    <mat-form-field>
      <mat-label>Preset Name</mat-label>
      <input [formControl]="enteredName" matInput type="text" />
    </mat-form-field>
  </form>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close="" mat-flat-button type="reset">{{ 'scheduler.general.cancel' | translate }}</button>
  <button (click)="save()" color="primary" mat-raised-button type="submit">Save</button>
  <!--  [disabled]="!systemConfigForm.valid"-->
</mat-dialog-actions>
